/**
 * Site 관련 React Query 키 (훅/캐시 유틸에서 공통 사용)
 */
export const siteKeys = {
  all: ['sites'] as const,
  lists: () => [...siteKeys.all, 'list'] as const,
  list: (companyId: number) => [...siteKeys.lists(), companyId] as const,
  details: () => [...siteKeys.all, 'detail'] as const,
  detail: (id: number) => [...siteKeys.details(), id] as const,
  info: (id: number) => [...siteKeys.details(), id, 'info'] as const,
};
